module.exports = __webpack_public_path__ + "static/claiming-denying-798df26bce1fadad68d08809ce56f2fe.jpg";